import {Injectable} from '@angular/core';
import {DataService} from '../data.service';
import { HttpClient } from '@angular/common/http';
import {catchError} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RatesTspScopeService extends DataService {

  private baseURI = this.apiUri + '/ratescope/';

  constructor(http: HttpClient) {
    super(http);
  }

  getTheCountOfPossibleDestinations(carrierId: number, originId: number, scopeType: string) {
    this.setUri(this.baseURI + 'possibleDestinationCount/' + carrierId + '/' + originId + '/' + scopeType);
    return this.get().pipe(catchError(this.handleError));
  }

}
